import { render } from "./PermissionTab.vue?vue&type=template&id=62dddbb5"
import script from "./PermissionTab.vue?vue&type=script&lang=js"
export * from "./PermissionTab.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__